module.exports = __webpack_public_path__ + "static/media/outline-shopping_basket-24px.7eaa19da.svg";